import { FC, PropsWithChildren } from 'react';

import { Card, Text, VSpacing } from '@hh.ru/magritte-ui';

interface CardCommonContentProps {
    title: string;
    text?: string;
    style: 'secondary' | 'negative-secondary';
}

export const CardCommonContent: FC<PropsWithChildren & CardCommonContentProps> = ({ children, title, text, style }) => (
    <Card padding={20} borderRadius={24} stretched style={style}>
        <Text typography="title-5-semibold">{title}</Text>
        {text && (
            <>
                <VSpacing default={6} />
                <Text>{text}</Text>
            </>
        )}
        {children}
    </Card>
);
